module.exports = __webpack_public_path__ + "static/media/workPvcCeilings13.2a096715.jpg";